
import cbsIcon from '../../assets/cbs/cbs.png';
import cbsIconModile from '../../assets/mobile/cbs/banner.png';
import advantageIcon1 from '../../assets/cbs/fast_icon.png';
import advantageIcon2 from '../../assets/cbs/adviser_icon.png';
import advantageIcon3 from '../../assets/cbs/price_icon.png';

export const metaInfo = {
    title: '公司注册_工商注册_公司注册流程_本地注册公司_全程代办注册',
    meta: [
        {
            name: 'keywords',
            content: '公司注册,工商注册,公司注册流程,本地注册公司,全程代办注册'
        },
        {
            name: 'description',
            content: '百度智能云提供公司注册、刻章、银行开户、税务报道、地址全包服务，专业顾问全程代办无需本人到场，费用透明，不成功全额退！'
        }
    ]
};

export const infoDesc = '三种套餐类型按需自由选择，助力初创企业快速起步';

export const baseInfo = {
    icon: cbsIcon,
    title: '工商注册服务',
    des: '迈出创业第一步，专业顾问为您提供工商注册服务',
    price: '0元',
    unit: '/年',
    hideOriginPrice: true,
    advantage: ['极速办理，快速下照', '专业顾问1对1陪伴', '工商财税一站式任选'],
    serviceAdvantage: ['经营性网站必备资质', '助企业合法合规经营', '新品上架，限时优惠'],
    advantageIcon: [advantageIcon1, advantageIcon2, advantageIcon3]
};

export const baseInfoModile = {
    icon: cbsIconModile,
    title: '工商注册服务',
    drawerTitle: '工商注册选配',
    des: '迈出创业第一步，专业顾问为您提供工商注册服务',
    price: '9.9',
    unit: '元/年',
    tips: [
        {text: '极速办理，快速下照', className: 'fast-icon'},
        {text: '专业顾问1对1陪伴', className: 'consult-icon'},
        {text: '工商财税一站式任选', className: 'cbs-icon'}
    ]
};

export const productInfo = {
    title: '服务介绍',
    modileTitle: '工商财税热门服务',
    infoDesc: '三种套餐类型按需自由选择，助力初创企业快速起步',
    infoList: [
        {
            title: '工商执照办理',
            content: '工商营业执照办理，是公司注册最基本的交付物',
            tag: ['普通注册', '超值套餐', '无忧套餐']
        },
        {
            title: '刻章服务',
            content: '包含公章、财务章、法人章的刻章服务',
            tag: ['普通注册', '超值套餐', '无忧套餐']
        },
        {
            title: '银行开户',
            content: '新公司若无银行账户，则无法处理支付收入汇款，工资发放，还可能会列为经营异常企业',
            tag: ['超值套餐', '无忧套餐']
        },
        {
            title: '税务报道',
            content: '核定税种和税率，按照法规要求，取得营业执照起30天需完成办理',
            tag: ['超值套餐', '无忧套餐']
        },
        {
            title: '代理记账（一年期）',
            content: '一年期代理记账服务，包含票据托管、会计审核、纳税申报、报表制定等一站式服务',
            tag: ['无忧套餐']
        },
        {
            title: '注册地址服务（一年期）',
            content: '根据国家法律要求，公司需使用商用的办公地址注册；为您提供一年期的地址挂靠服务',
            tag: ['无忧套餐']
        }
    ]
};

export const advantage = {
    title: '服务优势',
    infoDesc: '工商财税一站式企业服务，官方自营品牌保障，价格&流程全透明，极速办理5-7天发照',
    infoList: [
        {
            title: '官方自营品牌保障',
            className: 'advantage1',
            info: ['百度自营品牌保障安全贴心', '保密协议保护企业信息安全']
        },
        {
            title: '价格&流程全透明',
            className: 'advantage2',
            info: ['打破传统行业陋习，所有服务明码标价', '流程透明服务进度实时掌握']
        },
        {
            title: '极速办理5-7天发照',
            className: 'advantage3',
            info: ['无需漫长等待，办理过程迅速', '最快1天递交工商局，5-7天发照']
        },
        {
            title: '专业顾问1对1服务',
            className: 'advantage4',
            info: ['精选三年以上专业代理人，免费提供咨询', '1对1专业服务全程陪伴']
        }
    ]
};

export const process = {
    title: '服务流程',
    infoDesc: '业务办理流程及时间，因当地工商局政策不同存在差异，具体时间和流程请以实际为准，详情请咨询当地服务商'
};

export const material = {
    title: '办理材料',
    infoDesc: '核名、身份复印件、经营范围、住所使用证明、公司注册信息表',
    infoList: [
        {title: '核名', content: '2-5个名称字号'},
        {title: '身份复印件', content: '股东、法人、监事、财务负责人的身份证复印件'},
        {title: '经营范围', content: '拟定的经营范围'},
        {title: '住所使用证明', content: '经营地址和租房合同等材料'},
        {title: '公司注册信息表', content: '包含注册资本等信息'}
    ]
};

export const question = {
    title: '常见问题',
    infoDesc: '下单咨询后，我怎么享受服务？',
    infoList: [
        {
            title: '下单咨询后，我怎么享受服务？',
            content: '咨询下单成功后，将会有专业服务人员与您联系，进行一对一服务。',
            className: 'q1'
        },
        {
            title: '我没有公司注册地址怎么办？',
            content: '百度智能云服务商会提供给您所需公司虚拟地址，提供地址均为认证地址，放心可靠。',
            className: 'q3'
        },
        {
            title: '公司注册需要多少钱？',
            content: '具体城市和区域，费用不同。公司设立还可能需要其他增值服务，例如：公司地址、税控托管、银行开户、代理记账等，因此费用会有不同, 需单独购买。',
            className: 'q3'
        },
        {
            title: '会有额外收费吗？',
            content: '只有在您已经确认提交工商系统申请后，信息需要修改，例如公司名称、注册地址、主要负责人信息、注册资本等信息变更，需要额外收费。',
            className: 'q4'
        },
        {
            title: '经营范围怎么写？',
            content: '经营范围主要涉及税收和经营限制，从税收方面考虑可与专业会计沟通，从经营限制方面考虑则如实填写，若使用虚拟地址注册，经营范围在部分地区有特殊要求。经营范围专业话术，专业服务人员会帮您填写。',
            className: 'q5'
        },
        {
            title: '为什么注册公司9.9元，但是需要购买“园区银行开户”？',
            content: '您好，我们是为了配合园区，核查并确保落户公司不从事非法经营事项。'
                + '1、公司法要求公司业务往来需要银行开户；'
                + '2、税收征管法第十五条规定，企业自领取营业执照之日起三十日内，持有关证件，向税务机关申报办理税务登记，也需要客户银行开户；'
                + '3、公安部门反电信诈骗、防偷税漏税执法要求，因为银行账户可以体现公司资金往来及是否异常。',
            className: 'q6'
        },
        {
            title: '为什么注册公司9.9元，但是一直推荐购买代理记账？我不需要',
            content: '您好， 近年来，电信诈骗案件持续多发高发，不法分子不断翻新作案手法，严重危害人民群众财产安全。为此央行发布了《关于加强支付结算管理防范电信网络新型违法犯罪有关事项的通知》，'
                + '所以为了避免“部分人员使用园区地址注册公司用于违法犯罪”，园区在银行开户，代理记账，税务登记等几个步骤，希望客户交由园区指定代办，防范风险。'
                + '如果您自己去办理，且后续提供相应凭证给到园区审核，园区也是认可的，但是客户后续不向园区提供自己办理的凭证，园区会对客户地址标记“异常”处理，回收客户园区地址。'
                + '政策依据为，政府要求“根据甲方的要求对企业进行日常管理，对有异常的企业或者工商局列入黑名单的企业，需要协助甲方进行清理。',
            className: 'q7'
        },
        {
            title: '为什么宣传9.9元注册公司，但是还需要收取其他费用？',
            content: '您好，我们确实为您免费注册办理公司执照，代理记账属于公司后续经营，不归属在注册办理公司的内容中，您享受了园区免费地址权益，就需要遵守园区对防范风险的要求。'
                + '园区为了配合公安部门反电信诈骗、防偷税漏税执法，所以要求免费使用园区地址的公司客户，统一代办其他财税服务',
            className: 'q8'
        }
    ]
};

export const companyDataSource = [
    {
        label: '有限公司',
        value: '有限公司',
        _value: 'LIMITED_COMPANY'
    },
    {
        label: '股份有限公司',
        value: '股份有限公司',
        _value: 'LIMITED_LIABILITY_COMPANY'
    },
    {
        label: '集团公司',
        value: '集团公司',
        _value: 'GROUP_COMPANY'
    }
];

export const taxpayerTypeDataSource = [
    {
        label: '小规模纳税人',
        value: '小规模纳税人',
        _value: 'SMALL_SCALE_TAXPAYER'
    },
    {
        label: '一般纳税人',
        value: '一般纳税人',
        _value: 'GENERAL_TAXPAYER'
    }
];

export const serviceTypeDataSource = [
    {
        label: '公司注册',
        value: 'COMPANY_REGISTRATION',
        serviceContent: ['LICENSE', 'ENGRAVE_CHAPTER'],
        content: '执照办理+刻章'
    },
    {
        label: '公司注册超值套餐',
        value: 'SUPER_VALUE',
        serviceContent: ['LICENSE', 'ENGRAVE_CHAPTER', 'BANK_ACCACCOUNT', 'TAX_REPORT'],
        content: '执照办理+刻章+银行开户+税务报道'
    },
    {
        label: '公司注册无忧套餐',
        value: 'WORRY_FREE',
        serviceContent: ['LICENSE', 'ENGRAVE_CHAPTER', 'BANK_ACCACCOUNT',
            'TAX_REPORT', 'BOOKKEEPING', 'REGISTERED_ADDRESS'],
        content: '执照办理+刻章+银行开户+税务报道+1年代理记账+1年注册地址'
    }
];

export const bizTypeSource = {
    COMPANY_REGISTRATION: 'COMREG',
    SUPER_VALUE: 'PACKAGE',
    WORRY_FREE: 'PACKAGE'
};

export const serviceContentDataSource = {
    COMPANY_REGISTRATION: ['工商执照办理', '刻章服务'],
    SUPER_VALUE: ['工商执照办理', '刻章服务', '银行开户', '税务报道'],
    WORRY_FREE: ['工商执照办理', '刻章服务', '银行开户',
    '税务报道', '代理记账服务（一年期）', '注册地址服务（一年期）']
};

export const areaIndexDataSource = {
    COMPANY_REGISTRATION: 2,
    SUPER_VALUE: 4,
    WORRY_FREE: 6
};

export const packageTypeDataSource = {
    COMPANY_REGISTRATION: '',
    SUPER_VALUE: 1,
    WORRY_FREE: 2
};

export const packageDataSource = [
    {
        label: '执照办理+刻章',
        value: 2
    },
    {
        label: '执照办理+刻章+银行开户+税务报道',
        value: 4
    },
    {
        label: '执照办理+刻章+银行开户+税务报道+1年代理记账+1年注册地址',
        value: 6
    }
];

export const companyScopeList = [
    {type: '文化传媒类', value: '文化传媒类'},
    {type: '科技类', value: '科技类'},
    {type: '影业类', value: '影业类'},
    {type: '贸易类', value: '贸易类'},
    {type: '咨询类', value: '咨询类'},
    {type: '广告类', value: '广告类'},
    {type: '管理类', value: '管理类'},
    {type: '租赁类', value: '租赁类'},
    {type: '代理类', value: '代理类'},
    {type: '培训类', value: '培训类'},
    {type: '设计类', value: '设计类'},
    {type: '服务类', value: '服务类'},
    {type: '工程类', value: '工程类'}
];
